// eslint-disable-next-line no-unused-vars
import React from 'react'
import { withRouter } from 'router'
import classNames from 'classnames'

import styles from './style.module.scss'

const MobileLayout = ({ children }) => {
  return <div className={classNames(styles.mobileLayout, 'mobile-layout')}>{children}</div>
}

export default withRouter(MobileLayout)
